import { RouterProvider, createBrowserRouter } from "react-router-dom";
import GoogleAnalytics from "./components/analytics/GoogleAnalytics";
import routes from "./routes";

function App() {
  const router = createBrowserRouter(routes);
  return (
    <>
      <GoogleAnalytics />
      <RouterProvider router={router} />
    </>
  );
}

export default App;
